import axios from "axios";
import { Base_URL } from "../url";

export const fetchUnpostedInvoices = async (id) => {
  try {
    const response = await axios.get(`${Base_URL}/Invoices/GetUnpostedInvoices/${id}`);
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error fetching posted invoices!";
  }
};

export const fetchpostedInvoices = async (id) => {
  try {
    const response = await axios.get(`${Base_URL}/Invoices/GetPostedInvoices/${id}`);
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error fetching posted invoices!";
  }
};

 // adjust if needed

export const updateInvoicePostedStatus = async (invoiceId, changedBy, remarks = "") => {
  try {
    const response = await axios.post(`${Base_URL}/Invoices/UpdateInvoicePostedStatus`, {
      invoiceId,
      changedBy,
      remarks
    });
    return response.data;
  } catch (error) {
    // prefer the server error payload if available
    const err = error?.response?.data || error?.message || "Error updating invoice status!";
    throw err;
  }
};


export const updateCancelInvoiceStatus = async (invoiceId, changedBy) => {
  try {
    const response = await axios.post(`${Base_URL}/Invoices/UpdateCancelledStatus`, {
      invoiceId,
      changedBy
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error updating invoice status!";
  }
};

export const updateInvoiceHeader = async (invoiceId, invoiceData) => {
  try {
    const response = await axios.put(
      `${Base_URL}/Invoices/UpdateInvoiceHeader?invoiceId=${invoiceId}`,
      invoiceData
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error updating invoice header!";
  }
};

export const getInvoiceData = async (invoiceId) => {
  try {
    const response = await axios.get(`${Base_URL}/Invoices/providedataforinvoicetemplate?InvoiceId=${invoiceId}`);
    console.log(response, 'response')
    if (response.status === 200) {
      return response.data;
    } 
  } catch (error) {
    throw error.response?.data || "Error fetching posted invoices!";
  }
};
export const getCreditNoteData = async (invoiceId) => {
  try {
    const response = await axios.get(`${Base_URL}/CreditNote/providedataforcreditNote?creditNoteId=${invoiceId}`);
    console.log(response, 'response')
    if (response.status === 200) {
      return response.data;
    } 
  } catch (error) {
    throw error.response?.data || "Error fetching posted invoices!";
  }
};
export const getDebitNoteData = async (invoiceId) => {
  try {
    const response = await axios.get(`${Base_URL}/CreditNote/providedatafordebitNote?creditNoteId=${invoiceId}`);
    console.log(response, 'response')
    if (response.status === 200) {
      return response.data;
    } 
  } catch (error) {
    throw error.response?.data || "Error fetching posted invoices!";
  }
};


export const getAllInvoices=async()=>{
  try{
    const response =await axios.get(`${Base_URL}/Invoices/GetAllInvoiceHeaders`);
    console.log(response);
    return response.data
  }
  catch(error)
  {
    throw error.response?.data || "Error fetching invoices!";
  }
}

export const saveAdvancePayment = async (payload) => {
  try {
    const res = await axios.post(`${Base_URL}/AdvancePayment`, payload);
    return res.data;
  } catch (err) {
    console.error("Error saving advance payment:", err);
    throw err;
  }
};